export enum DiscountsRouteNames {
  DISCOUNTS_ROOT = 'DiscountsRoot',
  DISCOUNTS_LIST = 'DiscountsRoot/Discounts',
  DISCOUNTS_CREATE = 'DiscountsRoot/Discounts/Create',
  DISCOUNTS_UPDATE = 'DiscountsRoot/Discounts/Update',
}
